import {
  persistAndStripPasswordResetLocation,
  getRedirectForPasswordResetRoute,
} from '~/utils/password-reset-finish'

export default function ({ app, $gtm }) {
  persistAndStripPasswordResetLocation()

  app.router.beforeEach((to, from, next) => {
    const redirect = getRedirectForPasswordResetRoute(to)
    if (redirect) {
      next(redirect)
      return
    }

    next()
  })

  // GTM autoInit is false so gtm.js cannot load (or send Referer) until the URL is clean.
  if ($gtm && typeof $gtm.init === 'function') {
    $gtm.init()
  }
}
